import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

try {
  const rootElement = document.getElementById('root');

  if (!rootElement) {
    throw new Error('Root element not found');
  }

  if (import.meta.env.MODE === 'mock') {
    const { enableMocking } = await import('./configs/enableMocking.ts');
    await enableMocking();
    const { AppMock } = await import('./App.mock.tsx');
    createRoot(rootElement).render(
      <StrictMode>
        <AppMock />
      </StrictMode>,
    );
  } else {
    const { App } = await import('./App.tsx');
    createRoot(rootElement).render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  }
} catch (error: unknown) {
  console.error('[main] Failed to bootstrap application', error);
  throw error;
}
